module.exports = __webpack_public_path__ + "static/img/ksznn_3d_banner.2b60c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/ksznn_3d_banner.png
// module id = BeLy
// module chunks = 0